import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import get from 'get-value';
import classNames from 'classnames';
import { InputsProps } from './interface';
import ValidationIcon from '../Icons/ValidationIcon';
import { Select as CustomSelect } from 'shared/Inputs';
import { Option } from 'shared/interface/globalInterface';
import QuestionIcon from 'shared/Icons/QuestionIcon/QuestionIcon';
import HelperText from 'shared/HelperText/HelperText';

import './styles/_FormSelect.scss';

type Props = {
  options: Option[];
};

const FormSelect: React.FC<InputsProps & Props> = ({ field, form, options, ...props }) => {
  const { name } = field;
  const { touched, errors } = form;
  const {
    label,
    labelClass = 'form__label',
    helperText = '',
    inputWidth = 6,
    iconWidth = 6,
    spacing = 1,
    wrapperClass = 'form__wrapper',
    showBorder = true,
    required,
    helperContent,
  } = props as any;

  const [showHelperText, setShowHelperText] = useState<boolean>(false);
  const hasHelper = Boolean(helperText || helperContent);

  const nestedError = get(errors, name);
  const nestedTouched = get(touched, name);

  const containerClass = classNames(wrapperClass, 'form-select', {
    'form__field-error': nestedTouched && nestedError,
    'no-border': !showBorder,
  });

  const selected = field.value;
  const selectedOption = options.find((o) => o.value === field.value);
  const selectedLabel = selectedOption ? selectedOption.option : '';

  const handleSelected = (option: any) => {
    form.setFieldValue(field.name, option.value);
  };

  return (
    <div className={containerClass}>
      <label htmlFor={name} className={labelClass}>
        {label} {required && <span className="asterisk">*</span>}
        {hasHelper && (
          <QuestionIcon setShowHelperText={setShowHelperText} wrapperClassName="form-control--show-helper">
            {showHelperText && (
              <HelperText helperText={helperText} helperContent={helperContent} showHelperText={showHelperText} />
            )}
          </QuestionIcon>
        )}
      </label>

      <Grid container spacing={spacing} alignItems="center">
        <Grid item xs={inputWidth} className="select form-grid__item--big form-grid__item--select">
          <select hidden={true} id={name} {...field}>
            <option disabled value="" className="placeholder">
              Please select...
            </option>
            {options.map((option) => (
              <option key={option.id || option.value} value={option.value}>
                {option.option}
              </option>
            ))}
          </select>

          <CustomSelect
            options={options}
            name={field.name}
            onSelected={handleSelected}
            disabled={false}
            selected={{ value: selected, label: selectedLabel }}
            isRequired={required}
          />
        </Grid>
        <Grid item xs={iconWidth} className="form-grid__item--small">
          <ValidationIcon hasError={!!nestedError} wasTouched={!!nestedTouched} />
        </Grid>
      </Grid>
      {nestedTouched && nestedError && <div className="error">{nestedError}</div>}
    </div>
  );
};

export default FormSelect;
